"use client";

import BlokWrap from "@/components/atoms/BlokWrap";
import type { LiveShoppingStoryblok } from "@/types/storyblok-blok-types";
import { type SbBlokData, storyblokEditable } from "@storyblok/react/rsc";
import { useEffect } from "react";
import styles from "./LiveShopping.module.css";

export interface LiveShoppingBlokProps {
  blok: LiveShoppingStoryblok;
  preview: boolean;
}

const SPRII_SRC = "https://widget.cdn.sprii.shop/widget-309336525185.js";

export const LiveShoppingBlok = ({ blok }: LiveShoppingBlokProps) => {
  useEffect(() => {
    if (document.querySelector(`script[src="${SPRII_SRC}"]`)) return;
    const script = document.createElement("script");
    script.src = SPRII_SRC;
    script.type = "module";
    script.crossOrigin = "anonymous";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <BlokWrap animated="" {...storyblokEditable(blok as unknown as SbBlokData)}>
      <div
        data-sprii-gallery-id={blok.id}
        className={`sprii-gallery-area ${styles.stream}`}
      ></div>
    </BlokWrap>
  );
};
